import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const usePlannerViewWeekStartDate = () => {
  const { startDate: routeStartDate } = useParams();
  const lastUsedStartDate = useSelector(
    (state) => state.endUserPlanner.currentPlannerViewWeekStartDate,
  );
  return routeStartDate || lastUsedStartDate;
};
